module.exports = __webpack_public_path__ + "static/img/gov.5b1656b0.png";